import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/** Resolve image URLs: handles relative /api/uploads/ paths, old domain rewrites, and external URLs */
export function resolveImageUrl(url) {
  if (!url) return '';
  if (url.startsWith('/api/uploads/')) return `${BACKEND}${url}`;
  const idx = url.indexOf('/api/uploads/');
  if (idx > 0) return `${BACKEND}${url.substring(idx)}`;
  return url;
}
